import { render, staticRenderFns } from "./SensorStatus.vue?vue&type=template&id=0fdb9b7c&scoped=true&"
import script from "./SensorStatus.vue?vue&type=script&lang=ts&"
export * from "./SensorStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SensorStatus.vue?vue&type=style&index=0&id=0fdb9b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb9b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VRow})
